// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #1e2025;
  --additional-color: #ffffff;
  --accent-color: #272a31;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--primary-color);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--accent-color);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--additional-color);
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

html, body {
  min-width: 500px;
}

body {
  font-size: 14px;
  background: var(--primary-color);
  color: #BBB7B7;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

main:not(.main-admin) {
  height: 100vh;
  min-height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.message-error-code {
  position: relative;
  color: #F00;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.message-error-code + .typed-cursor {
  color: #F00;
}

.login {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.login__header {
  margin-bottom: 10px;
}
.login__item {
  margin-bottom: 10px;
}
.login form {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 300px;
}

.main-admin {
  position: relative;
  display: flex;
  gap: 10px;
  padding: 10px;
}
@media (max-width: 1200px) {
  .main-admin {
    flex-direction: column;
    width: 100%;
  }
}
.main-admin__tabs {
  display: flex;
  gap: 30px;
  border-bottom: 1px solid #2b2b2b;
  margin-bottom: 25px;
  width: 100%;
}
.main-admin__tab {
  padding: 10px 0;
  color: #BBB7B7;
  cursor: pointer;
  font-size: 15px;
  position: relative;
  transition: color 0.3s;
}
.main-admin__tab:hover {
  color: #fff;
}
.main-admin__tab:hover::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #fff;
}
.main-admin__tab.active {
  color: #fff;
  font-weight: 500;
}
.main-admin__tab.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #fff;
}
.main-admin__header {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.main-admin__buttons {
  display: flex;
  gap: 20px;
}
.main-admin__filters {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 767px) {
  .main-admin__filters {
    align-items: start;
    flex-direction: column;
  }
}
.main-admin__filters-block {
  display: flex;
  flex-direction: column;
  justify-items: flex-end;
}
.main-admin__filters-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
@media (max-width: 767px) {
  .main-admin__filters-wrapper {
    align-items: start;
    flex-direction: column;
  }
}
.main-admin__filters-list {
  display: flex;
  margin-left: 25px;
  margin-bottom: 20px;
  gap: 15px;
}
@media (max-width: 767px) {
  .main-admin__filters-list {
    justify-content: center;
  }
}
.main-admin__content {
  position: relative;
  background-color: #131313;
  box-shadow: var(--container-shadow);
  border-radius: 10px;
  padding: 16px;
  width: calc(100% - 80px);
}
@media (max-width: 1200px) {
  .main-admin__content {
    flex-direction: column;
    width: 100%;
  }
}
.main-admin__form {
  display: flex;
  gap: 20px;
}
@media (max-width: 992px) {
  .main-admin__form {
    flex-direction: column;
  }
}
.main-admin__form-group {
  display: flex;
  gap: 20px;
}
@media (max-width: 1400px) {
  .main-admin__form-group {
    flex-direction: column;
  }
}
.main-admin__form-group > div {
  width: 40%;
}
.main-admin__form-group > div:first-child {
  width: 60%;
}
@media (max-width: 1400px) {
  .main-admin__form-group > div:first-child {
    width: 100%;
  }
}
@media (max-width: 1400px) {
  .main-admin__form-group > div {
    width: 100%;
  }
}
.main-admin__form-block {
  width: 60%;
}
.main-admin__form-block:first-child {
  width: 40%;
}
@media (max-width: 1400px) {
  .main-admin__form-block:first-child {
    width: 50%;
  }
}
@media (max-width: 992px) {
  .main-admin__form-block:first-child {
    width: 100%;
  }
}
@media (max-width: 1400px) {
  .main-admin__form-block {
    width: 50%;
  }
}
@media (max-width: 992px) {
  .main-admin__form-block {
    width: 100%;
  }
}
.main-admin__input {
  margin-bottom: 20px;
}
.main-admin__card {
  position: relative;
  padding: 40px;
  background: var(--primary-color);
  border-radius: 12px;
}
.main-admin__card-title {
  font-size: 24px;
  margin-bottom: 20px;
}
.main-admin__card-item {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #131313;
  border-radius: 12px;
}
.main-admin__card-item span:first-child {
  color: #fff;
  text-transform: uppercase;
}
.main-admin__card-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.selected-info {
  display: flex;
  align-items: center;
}
.selected-info span {
  padding: 0 10px;
}

.settings-form__group {
  margin-bottom: 20px;
}
.settings-form__input {
  display: flex;
  gap: 5px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.settings-form__input input {
  display: inline-block;
  width: 100%;
  padding: 11px 10px;
  border: none;
  border-radius: 8.5px;
  background: #2b2b2b;
  color: #fff;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
}
.settings-form__input textarea {
  display: inline-block;
  width: 100%;
  padding: 11px 10px;
  border: none;
  border-radius: 8.5px;
  background: #2b2b2b;
  color: #fff;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  resize: none;
  min-height: 250px;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss","webpack://./src/styles/_scrollbar.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,2BAAA;EACA,uBAAA;AAEF;;ACLA,UAAA;AACA;EACE,UAAA;ADQF;;ACNA,UAAA;AACA;EACE,gCCNK;AFeP;;ACPA,WAAA;AACA;EACE,+BCTQ;AFmBV;;ACRA,oBAAA;AACA;EACE,mCCZW;AFuBb;;AAZA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;AAeF;;AAbA;EACE,gBAAA;AAgBF;;AAbA;EACE,eAAA;EACA,gCExBK;EFyBL,cAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAeF;;AAXA;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAcF;;AAVA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAaF;AAZE;EACE,WAAA;AAcJ;;AAVA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAaF;AAZE;EACE,mBAAA;AAcJ;AAZE;EACE,mBAAA;AAcJ;AAZE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AAcJ;;AATA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;AAYF;AAXE;EALF;IAMI,sBAAA;IACA,WAAA;EAcF;AACF;AAbE;EACE,aAAA;EACA,SAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;AAeJ;AAZE;EACE,eAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAcJ;AAZI;EACE,WAAA;AAcN;AAbM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAeR;AAXI;EACE,WAAA;EACA,gBAAA;AAaN;AAZM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;AAcR;AAVE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAYJ;AAVE;EACE,aAAA;EACA,SAAA;AAYJ;AAVE;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;AAYJ;AAXI;EALF;IAMI,kBAAA;IACA,sBAAA;EAcJ;AACF;AAbI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAeN;AAbI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AAeN;AAdM;EAJF;IAKI,kBAAA;IACA,sBAAA;EAiBN;AACF;AAfI;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,SAAA;AAiBN;AAhBM;EALF;IAMI,uBAAA;EAmBN;AACF;AAhBE;EACE,kBAAA;EACA,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;AAkBJ;AAjBI;EAPF;IAQI,sBAAA;IACA,WAAA;EAoBJ;AACF;AAlBE;EACE,aAAA;EACA,SAAA;AAoBJ;AAnBI;EAHF;IAII,sBAAA;EAsBJ;AACF;AArBI;EACE,aAAA;EACA,SAAA;AAuBN;AAtBM;EAHF;IAII,sBAAA;EAyBN;AACF;AAxBM;EAOE,UAAA;AAoBR;AA1BQ;EACE,UAAA;AA4BV;AA3BU;EAFF;IAGI,WAAA;EA8BV;AACF;AA3BQ;EARF;IASI,WAAA;EA8BR;AACF;AA3BI;EAUE,UAAA;AAoBN;AA7BM;EACE,UAAA;AA+BR;AA9BQ;EAFF;IAGI,UAAA;EAiCR;AACF;AAhCQ;EALF;IAMI,WAAA;EAmCR;AACF;AAhCM;EAXF;IAYI,UAAA;EAmCN;AACF;AAlCM;EAdF;IAeI,WAAA;EAqCN;AACF;AAjCE;EACE,mBAAA;AAmCJ;AAjCE;EACE,kBAAA;EACA,aAAA;EACA,gCE/OG;EFgPH,mBAAA;AAmCJ;AAlCI;EACE,eAAA;EACA,mBAAA;AAoCN;AAlCI;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBEtPI;EFuPJ,mBAAA;AAoCN;AAlCQ;EACE,WAAA;EACA,yBAAA;AAoCV;AAhCI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAkCN;;AA7BA;EACE,aAAA;EACA,mBAAA;AAgCF;AA/BE;EACE,eAAA;AAiCJ;;AA5BE;EACE,mBAAA;AA+BJ;AA7BE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;AA+BJ;AA9BI;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;AAgCN;AA9BI;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iCAAA;EACA,YAAA;EACA,iBAAA;AAgCN","sourcesContent":[":root {\r\n  --primary-color: #1e2025;\r\n  --additional-color: #ffffff;\r\n  --accent-color: #272a31;\r\n\r\n}\r\n@import './_variables';\r\n@import './_fonts';\r\n@import './_scrollbar';\r\n\r\n\r\n\r\n\r\n*{\r\n  padding: 0;\r\n  margin:0;\r\n  box-sizing: border-box;\r\n}\r\nhtml,body{\r\n  min-width: 500px;\r\n}\r\n\r\nbody{\r\n  font-size: 14px;\r\n  background: $main;\r\n  color: #BBB7B7;\r\n\r\n  font-family: 'Roboto',sans-serif;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n}\r\n\r\n\r\nmain:not(.main-admin){\r\n  height: 100vh;\r\n  min-height: 700px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n\r\n.message-error-code{\r\n  position: relative;\r\n  color: #F00;\r\n  text-align: center;\r\n  font-family: 'Roboto',sans-serif;\r\n  font-size: 13px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: normal;\r\n  + .typed-cursor{\r\n    color: #F00;\r\n  }\r\n}\r\n\r\n.login{\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  &__header{\r\n    margin-bottom: 10px;\r\n  }\r\n  &__item{\r\n    margin-bottom: 10px;\r\n  }\r\n  form{\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    max-width: 300px;\r\n  }\r\n}\r\n\r\n\r\n.main-admin{\r\n  position: relative;\r\n  display: flex;\r\n  gap: 10px;\r\n  padding: 10px;\r\n  @media (max-width:1200px){\r\n    flex-direction: column;\r\n    width: 100%;\r\n  }\r\n  &__tabs {\r\n    display: flex;\r\n    gap: 30px;\r\n    border-bottom: 1px solid #2b2b2b;\r\n    margin-bottom: 25px;\r\n    width: 100%;\r\n  }\r\n\r\n  &__tab {\r\n    padding: 10px 0;\r\n    color: #BBB7B7;\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n    position: relative;\r\n    transition: color 0.3s;\r\n\r\n    &:hover {\r\n      color: #fff;\r\n      &::after {\r\n        content: '';\r\n        position: absolute;\r\n        bottom: -1px;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 2px;\r\n        background-color: #fff;\r\n      }\r\n    }\r\n\r\n    &.active {\r\n      color: #fff;\r\n      font-weight: 500;\r\n      &::after {\r\n        content: '';\r\n        position: absolute;\r\n        bottom: -1px;\r\n        left: 0;\r\n        width: 100%;\r\n        height: 2px;\r\n        background-color: #fff;\r\n      }\r\n    }\r\n  }\r\n  &__header{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 30px;\r\n  }\r\n  &__buttons{\r\n    display: flex;\r\n    gap: 20px;\r\n  }\r\n  &__filters{\r\n    display: flex;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    @media (max-width:767px){\r\n      align-items: start;\r\n      flex-direction: column;\r\n    }\r\n    &-block{\r\n      display: flex;\r\n      flex-direction: column;\r\n      justify-items: flex-end;\r\n    }\r\n    &-wrapper{\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: flex-end;\r\n      @media (max-width:767px){\r\n        align-items: start;\r\n        flex-direction: column;\r\n      }\r\n    }\r\n    &-list{\r\n      display: flex;\r\n      margin-left: 25px;\r\n      margin-bottom: 20px;\r\n      gap: 15px;\r\n      @media (max-width:767px){\r\n        justify-content: center;\r\n      }\r\n    }\r\n  }\r\n  &__content{\r\n    position: relative;\r\n    background-color: #131313;\r\n    box-shadow: var(--container-shadow);\r\n    border-radius: 10px;\r\n    padding: 16px;\r\n    width: calc(100% - 80px);\r\n    @media (max-width:1200px){\r\n      flex-direction: column;\r\n      width: 100%;\r\n    }\r\n  }\r\n  &__form{\r\n    display: flex;\r\n    gap: 20px;\r\n    @media (max-width:992px){\r\n      flex-direction: column;\r\n    }\r\n    &-group{\r\n      display: flex;\r\n      gap: 20px;\r\n      @media (max-width:1400px){\r\n        flex-direction: column;\r\n      }\r\n      >div{\r\n        &:first-child{\r\n          width: 60%;\r\n          @media (max-width:1400px){\r\n            width: 100%;\r\n          }\r\n        }\r\n        width: 40%;\r\n        @media (max-width:1400px){\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n    &-block{\r\n      &:first-child{\r\n        width: 40%;\r\n        @media (max-width:1400px){\r\n          width: 50%;\r\n        }\r\n        @media (max-width:992px){\r\n          width: 100%;\r\n        }\r\n      }\r\n      width: 60%;\r\n      @media (max-width:1400px){\r\n        width: 50%;\r\n      }\r\n      @media (max-width:992px){\r\n        width: 100%;\r\n      }\r\n    }\r\n\r\n  }\r\n  &__input{\r\n    margin-bottom: 20px;\r\n  }\r\n  &__card{\r\n    position: relative;\r\n    padding: 40px;\r\n    background: $main;\r\n    border-radius: 12px;\r\n    &-title{\r\n      font-size: 24px;\r\n      margin-bottom: 20px;\r\n    }\r\n    &-item{\r\n      display: flex;\r\n      justify-content: space-between;\r\n      padding: 10px;\r\n      background: $primary;\r\n      border-radius: 12px;\r\n      span{\r\n        &:first-child{\r\n          color: #fff;\r\n          text-transform: uppercase;\r\n        }\r\n      }\r\n    }\r\n    &-content{\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 15px;\r\n    }\r\n  }\r\n}\r\n\r\n.selected-info{\r\n  display: flex;\r\n  align-items: center;\r\n  span{\r\n    padding: 0 10px;\r\n  }\r\n}\r\n\r\n.settings-form{\r\n  &__group{\r\n    margin-bottom: 20px;\r\n  }\r\n  &__input{\r\n    display: flex;\r\n    gap: 5px;\r\n    margin-bottom: 20px;\r\n    flex-wrap: wrap;\r\n    input{\r\n      display: inline-block;\r\n      width: 100%;\r\n      padding: 11px 10px;\r\n      border: none;\r\n      border-radius: 8.5px;\r\n      background: #2b2b2b;\r\n      color: #fff;\r\n      font-size: 14px;\r\n      font-family: 'Roboto',sans-serif;\r\n    }\r\n    textarea{\r\n      display: inline-block;\r\n      width: 100%;\r\n      padding: 11px 10px;\r\n      border: none;\r\n      border-radius: 8.5px;\r\n      background: #2b2b2b;\r\n      color: #fff;\r\n      font-size: 14px;\r\n      font-family: 'Roboto',sans-serif;\r\n      resize: none;\r\n      min-height: 250px;\r\n    }\r\n  }\r\n}","/* width */\r\n::-webkit-scrollbar {\r\n  width: 6px; }\r\n\r\n/* Track */\r\n::-webkit-scrollbar-track {\r\n  background: $main; }\r\n\r\n/* Handle */\r\n::-webkit-scrollbar-thumb {\r\n  background: $accent; }\r\n\r\n/* Handle on hover */\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: $additional; }","$main: var(--primary-color);\r\n$accent:  var(--accent-color);\r\n$additional: var(--additional-color);\r\n$primary: #131313;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
